import React from "react";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddEmployee from "../Registration/Employee/addEmployee";
import AltEmployee from "../Registration/Employee/altEmployee";
import DelEmployee from "../Registration/Employee/delEmployee";
import BottomBar from "../../Components/bottomBar/bottomBar";
import "./prelude.css";
import Api from "../../services/api";
import Alert from "../../Components/alert/Alert";
import TopBar from "../../Components/topBar/topBar";
import { handleColor } from "../../services/Functions";
import ReportEmployees from "../Reports/reportEmployees";

const PreludeEmployees = () => {
  return (
    <>
      <header>
        <TopBar></TopBar>{" "}
      </header>
      <main className="prelude_container">
        <Sidebar></Sidebar>
      </main>
      <BottomBar></BottomBar>
    </>
  );
};

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/employees")
      .then((response) => {
        response.data.response.forEach((element) => {
          array.push({
            Nome: element.name,
            Código: element.employee_code,
            Ativo: element.is_active ? "Sim" : "Não",
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;
    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1 ">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="list"
                  >
                    Funcionários
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Funcionário
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar Funcionário
                  </ListGroup.Item>
                  <ListGroup.Item
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar Funcionário
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "2%",
                marginLeft: "1%",
                width: "100%",
                height: "96%",
                overflow: "hidden",
              }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content style={{ height: "100%" }}>
                <Tab.Pane style={{ height: "100%" }} eventKey="list">
                  {this.handleClick ? <ReportEmployees /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="add">
                  {this.handleClick ? <AddEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="del">
                  {this.handleClick ? <DelEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="alt">
                  {this.handleClick ? <AltEmployee /> : null}
                </Tab.Pane>
                <Tab.Pane style={{ height: "100%" }} eventKey="del">
                  {this.handleClick ? <DelEmployee /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default PreludeEmployees;
